import { render, staticRenderFns } from "./c-loading.vue?vue&type=template&id=40421d6f&"
import script from "./c-loading.vue?vue&type=script&lang=js&"
export * from "./c-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports